import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Modal, message } from 'antd';
import FormList from '../../basicElement/FormList.new.js';
import actions from '../store/actions';

let constants = {};
function getContants(type) {
    switch(type) {
        case 'add': 
            return {
                add: true,
                title: '添加报价单',
            };
        case 'edit': 
            return {
                edit: true,
                title: '修改报价单',
            };
        case 'update': 
            return {
                update: true,
                title: '修改报价单',
            };
    }
}

class Update extends Component {
    state = {
        data: {},
        loading: false,
    }
    
    componentDidUpdate(prevProps) {
        const { type, visible, quotationInfo } = this.props;
        constants = getContants(type);
        if (!prevProps.visible && visible) {
            this.setState({
                data: {
                    serverType: 'CRC服务',
                    quotationType: 'FTE制报价',
                    ...quotationInfo,
                },
            });
        }
    }

    hide = () => {
        this.props.hide();
    }

    handleChange = ({value, key}) => {
        const { data } = this.state;
        data[key] = value;
        this.setState({ data });
    }

    getColumns = () => {
        const { data } = this.state;

        // 字段属性配置
        const columns = [{
            key: 'serverType',
            type: 'text',
            attr: {
                name: '服务类型',
            }
        }, {
            key: 'quotationType',
            type: 'text',
            attr: {
                name: '报价类型',
            }
        }, {
            key: 'language',
            type: 'select',
            attr: {
                name: '报价单语言',
                options: [{ label: '中文', value: 'zh' }, { label: '英文', value: 'en' }],
            },
            attrRules: {
                required: true,
            }
        }, {
            key: 'currency',
            type: 'select',
            attr: {
                name: '币种',
                options: [{ label: '人民币（CNY）', value: 'CNY' }, { label: '美元（USD）', value: 'USD' }],
            },
            attrRules: {
                required: true,
            }
        }, {
            key: 'exChange',
            type: 'inputNumber',
            attr: {
                name: '汇率',
                max: 99999999999,
                style: { width: 100, margin: '0 4px' },
            },
            attrRules: {
                prefix: '1 美元 = ',
                suffix: '人民币',
                required: true,
            },
            display: !!data.currency && data.currency !== 'CNY',
        }, {
            key: 'hasGuidePrice',
            type: 'radio',
            attr: {
                name: '是否已获得指导价',
                options: [{ label: '是', value: '1' }, { label: '否', value: '0' }],
            },
            attrRules: {
                required: true,
            }
        }, {
            key: 'guidePrice',
            type: 'inputNumber',
            attr: {
                name: '报价单指导价',
                min: 0,
                precision: 2,
            },
            attrRules: {
                unit: '万元',
                required: true,
            },
            display: data.hasGuidePrice == 1,
        }];

        // 字段值、显示状态配置
        const traverseColumns = function (columns) {
            columns.forEach(column => {
                const { key, attr } = column;
                attr.value = data[key];
            });
        }
        traverseColumns(columns);

        return columns;
    }

    confirm = () => {
        const hasWritten = this.formRef.validate();
        if (!hasWritten) return;

        this.confirmLanguage();
    }

    confirmLanguage = () => {
        const { quotationInfo } = this.props;
        const { data } = this.state;
        const { language, hasCommit } = data;
        if ((constants.edit || constants.update) && (language !== quotationInfo.language)) {
            Modal.confirm({
                iconType: 'question-circle',
                title: <div style={{ marginLeft: 42 }}>确定修改报价单语言？</div>,
                content: `修改后，此报价单自动使用变更后的语言${hasCommit ? '（已存档的版本使用原语言作为默认语言）' : ''}`,
                onOk: () => {
                    this.confirmCurrency();
                },
            });
        } else {
            this.confirmCurrency();
        }
    }

    confirmCurrency = () => {
        const { quotationInfo } = this.props;
        const { data } = this.state;
        if ((constants.edit || constants.update) && (data.currency !== quotationInfo.currency)) {
            Modal.confirm({
                iconType: 'question-circle',
                title: <div style={{ marginLeft: 42 }}>确定修改报价单币种？</div>,
                content: '修改后，此报价单中的金额使用原金额和汇率进行自动折算',
                onOk: () => {
                    this.saveData();
                },
            });
        } else {
            this.saveData();
        }
    }

    saveData = () => {
        const { data } = this.state;
        this.hide();
        this.props.saveQuotationInfo({ ...data });
        location.href = './#/quotation/production';
    }

    render() {
        const { visible } = this.props;
        const { loading } = this.state;
        return (
            <Modal
                title={constants.title}
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                maskClosable={false}
                width="420px"
                confirmLoading={loading}
            >
                <FormList
                    fieldWidth={200}
                    className="updateQuotation-list"
                    columns={this.getColumns()}
                    onChange={this.handleChange}
                    ref={el => this.formRef = el}
                />
            </Modal>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        ...state.quotationState,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        ...bindActionCreators(actions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Update);



// WEBPACK FOOTER //
// ./src/components/quotation/Components/Update.js